import { CurrentUser } from "../models/current-user";
import { EnumDto } from "../models/enum-dto";

export class Parameters
{
  static loggedUser: CurrentUser = {
    id: 0,
    name: 'Unlogged',
    familyName: '',
    email: '',
    role: 4,
    mass: 1.0,
    userName: '',
    organizations: []
  };

  static roles: EnumDto[] = [];
  static receivers: EnumDto[] = [];

  // Trasforma la lista di interi in una lista con il nome dei Ruoli
  static decodificaRuoli(role: number): string[] {
    var result: string[] = [];

    var enumRole = this.roles.find(r => r.id === role);
    if (enumRole !== undefined) {
      result.push(enumRole.description);
    } else {
      result.push(`Unknown: ${role}`)
    }

    return result;
  }
}
